<template>
  <pui-input
    ref="editor"
    type="number"
    :disabled="editor.disabled"
    v-model="getValue"
    :min="editor.min"
    :max="editor.max"
    :step="editor.step"
    @change="onValueChanged"
    @blur="onBlur"
  >
  </pui-input>
</template>
<script>
import TableAttributeEditorMixin from './TableAttributeEditorMixin';

export default {
  components: {},
  mixins: [TableAttributeEditorMixin],
};
</script>
